import AdminLayout from "components/layout/AdminLayout"
import SettingsLayout from "components/layout/SettingsLayout"
import SettingsGeneral from "components/shopSettings/SettingsGeneral"
import { ReactElement } from "react"

const GeneralSettingsPage = () => {
  return <SettingsGeneral />
}

GeneralSettingsPage.getLayout = (page: ReactElement) => {
  return (
    <AdminLayout>
      <SettingsLayout>{page}</SettingsLayout>
    </AdminLayout>
  )
}

export default GeneralSettingsPage
